import React from 'react';
import { RouteObject } from 'react-router-dom';
import { PermissionCheckComponent } from '../../../common/component/layout/PermissionCheckComponent';
import { CspPath } from '../../../CspPath';
import { PermissionType } from '../../security/type/PermissionType';
import { PathUtil } from '../util/PathUtil';

const SiteListPage = React.lazy(() => import(/* webpackPrefetch: true */ '../../site/site-list/page/SiteListPage'));

const EditEcApprovalStatusesDrawerContainer = React.lazy(
  () =>
    import(
      /* webpackPrefetch: true */ '../../site/site-list/ec-approval/container/EditEcApprovalStatusesDrawerContainer'
    ),
);

export const SiteListRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <PermissionCheckComponent permission={PermissionType.CAN_VIEW_SITES}>
        <SiteListPage />
      </PermissionCheckComponent>
    ),
    children: [
      {
        path: PathUtil.toRelativePath(CspPath.SITE_LIST, CspPath.SITE_LIST_CHANGE_EC_APPROVAL_STATUSES, true),
        element: <EditEcApprovalStatusesDrawerContainer />,
      },
    ],
  },
];
